<div class="dashboard-layout">
  <app-toast></app-toast>
  <app-sidebar></app-sidebar>

  <div class="main-area">
    <app-navbar
      pageTitle="Dashboard"
      pageSubtitle="AI-powered intelligence from enterprise documents."
    ></app-navbar>

    <div class="content page-loading-wrap" *ngIf="sourcesLoading()">
      <div class="page-spinner" aria-label="Loading dashboard"></div>
    </div>

    <div class="content no-insights-wrap" *ngIf="hasNoSources">
      <div class="no-insights-state">
        <div class="no-insights-icon">
          <img src="assets/images/no-insights.png" alt="" class="no-insights-img">
        </div>
        <h2 class="no-insights-title">No insights yet</h2>
        <p class="no-insights-desc">
          Connect a data source, create a batch, and run AI analysis to generate insights, knowledge graphs, and inferences.
        </p>
        <button type="button" class="btn-connect-source" (click)="openConnectModal()">Connect data source</button>
      </div>
    </div>

    <div class="content dashboard-content" *ngIf="hasSources">

      <app-pending-reviews-banner scope="dashboard"></app-pending-reviews-banner>

      <div class="filters-bar">
        <div class="filters-left">
          <span class="filters-label">Filters</span>
          <label class="filter">
            <span class="filter-name">Classification</span>
            <select class="filter-select" [(ngModel)]="filterClassification" aria-label="Filter by classification">
              <option value="All">All</option>
              <option *ngFor="let c of classificationOptions" [value]="c">{{ c }}</option>
            </select>
          </label>
          <label class="filter">
            <span class="filter-name">Source</span>
            <select class="filter-select" [(ngModel)]="filterSource" aria-label="Filter by source">
              <option value="All">All</option>
              <option *ngFor="let s of sourceOptions" [value]="s">{{ s }}</option>
            </select>
          </label>
          <label class="filter">
            <span class="filter-name">Status</span>
            <select class="filter-select" [(ngModel)]="filterStatus" aria-label="Filter by status">
              <option value="All">All</option>
              <option *ngFor="let s of statusOptions" [value]="s">{{ s }}</option>
            </select>
          </label>
        </div>

        <div class="filters-right">
          <div class="filter-search">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#68728F" stroke-width="2" aria-hidden="true">
              <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
            </svg>
            <input
              type="search"
              placeholder="Search batches..."
              [(ngModel)]="batchSearch"
              aria-label="Search batches"
            />
          </div>
          <button
            type="button"
            class="btn-clear-filters"
            *ngIf="hasActiveFilters"
            (click)="clearFilters()"
          >
            Clear
          </button>
        </div>
      </div>

      <div class="stat-cards">
        <div class="stat-card">
          <div class="stat-icon blue-bg" aria-hidden="true">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#3B82F6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
              <polyline points="14 2 14 8 20 8"/>
            </svg>
          </div>
          <span class="stat-label">Documents Processed</span>
          <span class="skel skel-value" *ngIf="showSkeletons"></span>
          <span class="stat-value" *ngIf="!showSkeletons">{{ documentsProcessed | number }}</span>
          <span class="stat-hint" *ngIf="!showSkeletons && todayDocuments > 0">{{ todayDocuments | number }} today</span>
        </div>

        <div class="stat-card">
          <div class="stat-icon purple-bg" aria-hidden="true">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#A855F7" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M12 2L2 7l10 5 10-5-10-5z"/>
              <path d="M2 17l10 5 10-5"/>
              <path d="M2 12l10 5 10-5"/>
            </svg>
          </div>
          <span class="stat-label">Active Batches</span>
          <span class="skel skel-value" *ngIf="showSkeletons"></span>
          <span class="stat-value" *ngIf="!showSkeletons">{{ activeBatches }}</span>
          <span class="stat-hint warn" *ngIf="!showSkeletons && batchesNeedingReview > 0">{{ batchesNeedingReview }} need review</span>
        </div>

        <div class="stat-card">
          <div class="stat-icon orange-bg" aria-hidden="true">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#F97316" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M21.21 15.89A10 10 0 1 1 8 2.83"/>
              <path d="M22 12A10 10 0 0 0 12 2v10z"/>
            </svg>
          </div>
          <span class="stat-label">Sub Classifications</span>
          <span class="skel skel-value" *ngIf="showSkeletons"></span>
          <span class="stat-value" *ngIf="!showSkeletons">{{ subClassifications }}</span>
        </div>

        <div class="stat-card">
          <div class="stat-icon green-bg" aria-hidden="true">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#22C55E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
              <polyline points="22 4 12 14.01 9 11.01"/>
            </svg>
          </div>
          <span class="stat-label">Evidence Snippets</span>
          <span class="skel skel-value" *ngIf="showSkeletons"></span>
          <span class="stat-value" *ngIf="!showSkeletons">{{ evidenceSnippets | number }}</span>
        </div>

        <div class="stat-card">
          <div class="stat-icon teal-bg" aria-hidden="true">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#14B8A6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/>
              <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/>
            </svg>
          </div>
          <span class="stat-label">Access Roles in Use</span>
          <span class="skel skel-value" *ngIf="showSkeletons"></span>
          <span class="stat-value" *ngIf="!showSkeletons">{{ accessRolesInUse }}</span>
        </div>
      </div>

      <div class="charts-row">

        <div class="chart-card">
          <div class="chart-head">
            <h3 class="chart-title">Classification Summary</h3>
            <p class="chart-caption">Share of classified documents</p>
          </div>
          <div class="chart-body" *ngIf="!showSkeletons && classificationSummary.length > 0; else classEmpty">
            <div class="donut-column">
              <div class="donut-wrapper">
                <svg viewBox="0 0 100 100" class="donut-svg" aria-hidden="true">
                  <circle class="donut-track" cx="50" cy="50" r="35"/>
                  <circle
                    *ngFor="let item of classificationSummary"
                    class="donut-seg"
                    cx="50" cy="50" r="35"
                    [attr.stroke]="item.color"
                    [attr.stroke-dasharray]="(item.percentage * 2.199) + ' 219.9'"
                    [attr.stroke-dashoffset]="-(item.offset * 2.199)"
                    transform="rotate(-90 50 50)"
                  />
                </svg>
                <div class="donut-center">
                  <span class="donut-center-value">{{ classifiedDocuments | number }}</span>
                  <span class="donut-center-label">docs</span>
                </div>
              </div>
            </div>
            <div class="legend">
              <div class="legend-item" *ngFor="let item of classificationSummary">
                <span class="legend-dot" [style.background]="item.color"></span>
                <span class="legend-label" [title]="item.label">{{ item.label }}</span>
                <span class="legend-count" *ngIf="item.count != null">{{ item.count | number }}</span>
                <span class="legend-percent">{{ item.percentage }}%</span>
              </div>
            </div>
          </div>
          <ng-template #classEmpty>
            <div class="chart-empty" *ngIf="!showSkeletons">
              <p>No classification data yet.</p>
            </div>
            <div class="chart-skel" *ngIf="showSkeletons">
              <span class="skel skel-donut"></span>
              <div class="skel-legend">
                <span class="skel skel-line" *ngFor="let i of [1,2,3,4]"></span>
              </div>
            </div>
          </ng-template>
        </div>

        <div class="chart-card">
          <div class="chart-head">
            <h3 class="chart-title">Batch Status Overview</h3>
            <p class="chart-caption">Current mix of batch statuses</p>
          </div>
          <div class="chart-body" *ngIf="!showSkeletons && batchStatusOverview.length > 0; else batchEmpty">
            <div class="donut-column">
              <div class="donut-wrapper">
                <svg viewBox="0 0 100 100" class="donut-svg" aria-hidden="true">
                  <circle class="donut-track" cx="50" cy="50" r="35"/>
                  <circle
                    *ngFor="let item of batchStatusOverview"
                    class="donut-seg"
                    cx="50" cy="50" r="35"
                    [attr.stroke]="item.color"
                    [attr.stroke-dasharray]="(item.percentage * 2.199) + ' 219.9'"
                    [attr.stroke-dashoffset]="-(item.offset * 2.199)"
                    transform="rotate(-90 50 50)"
                  />
                </svg>
                <div class="donut-center">
                  <span class="donut-center-value">{{ totalBatches }}</span>
                  <span class="donut-center-label">batches</span>
                </div>
              </div>
            </div>
            <div class="legend">
              <div class="legend-item" *ngFor="let item of batchStatusOverview">
                <span class="legend-dot" [style.background]="item.color"></span>
                <span class="legend-label" [title]="item.label">{{ item.label }}</span>
                <span class="legend-count" *ngIf="item.count != null">{{ item.count | number }}</span>
                <span class="legend-percent">{{ item.percentage }}%</span>
              </div>
            </div>
          </div>
          <ng-template #batchEmpty>
            <div class="chart-empty" *ngIf="!showSkeletons">
              <p>No batch data yet.</p>
            </div>
            <div class="chart-skel" *ngIf="showSkeletons">
              <span class="skel skel-donut"></span>
              <div class="skel-legend">
                <span class="skel skel-line" *ngFor="let i of [1,2,3,4]"></span>
              </div>
            </div>
          </ng-template>
        </div>

        <div class="chart-card bar-chart-card">
          <div class="chart-head">
            <h3 class="chart-title">Access Roles by Document Count</h3>
            <p class="chart-caption">Documents mapped to each role</p>
          </div>
          <div class="bar-chart" *ngIf="!showSkeletons && accessRolesByDocCount().length > 0; else rolesEmpty">
            <div class="bar-rows">
              <div class="bar-row" *ngFor="let item of accessRolesByDocCount()">
                <span class="bar-label" [title]="item.role">{{ item.role }}</span>
                <div class="bar-track">
                  <div class="bar-fill" [style.width.%]="(item.count / accessRolesAxisMax) * 100"></div>
                </div>
                <span class="bar-count">{{ item.count | number }}</span>
              </div>
            </div>
            <div class="bar-axis">
              <span class="bar-axis-spacer"></span>
              <div class="bar-axis-ticks">
                <span *ngFor="let tick of accessRolesAxis">{{ tick }}</span>
              </div>
              <span class="bar-axis-end"></span>
            </div>
          </div>
          <ng-template #rolesEmpty>
            <div class="chart-empty" *ngIf="!showSkeletons">
              <p>No access role data yet.</p>
            </div>
            <div class="bar-skel" *ngIf="showSkeletons">
              <span class="skel skel-bar" *ngFor="let i of [1,2,3,4,5]"></span>
            </div>
          </ng-template>
        </div>
      </div>

      <div class="bottom-row">
        <div class="table-card">
          <div class="card-header">
            <div>
              <h3 class="card-title">Batches in Progress</h3>
              <p class="card-caption">Latest activity across running batches</p>
            </div>
            <a routerLink="/manage-batches" class="view-all-link">
              View all
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
                <path d="M5 12h14"/><path d="M13 6l6 6-6 6"/>
              </svg>
            </a>
          </div>

          <div class="table-scroll">
            <table class="batches-table">
              <thead>
                <tr>
                  <th>Batch</th>
                  <th>Classification</th>
                  <th>Documents</th>
                  <th>Evidence</th>
                  <th>Access Role</th>
                  <th>Progress</th>
                  <th>Status</th>
                  <th>Updated</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  class="batch-row"
                  *ngFor="let row of filteredBatches"
                  (click)="openBatch(row.id)"
                  (keydown.enter)="openBatch(row.id)"
                  tabindex="0"
                >
                  <td class="batch-name-cell" [title]="row.name">{{ row.name }}</td>
                  <td>
                    <span class="badge" *ngIf="row.classification" [title]="row.classification">{{ row.classification }}</span>
                    <span class="muted" *ngIf="!row.classification">—</span>
                  </td>
                  <td class="num-cell">{{ row.documents | number }}</td>
                  <td class="num-cell">{{ row.evidence | number }}</td>
                  <td class="role-cell" [title]="row.accessRole || ''">{{ row.accessRole || '—' }}</td>
                  <td>
                    <div class="progress-cell">
                      <div class="progress-track">
                        <div class="progress-fill" [class]="progressFillClass(row.status)" [style.width.%]="row.progress"></div>
                      </div>
                      <span class="progress-percent">{{ row.progress }}%</span>
                    </div>
                  </td>
                  <td>
                    <span class="status-badge" [ngClass]="statusBadgeClass(row.status)">{{ row.status }}</span>
                  </td>
                  <td class="time-cell" [title]="formatTimestamp(row.updatedAt)">{{ timeAgo(row.updatedAt) }}</td>
                </tr>

                <tr *ngIf="(showSkeletons || dataLoading()) && filteredBatches.length === 0">
                  <td colspan="8" class="skel-cell">
                    <span class="skel skel-table-row" *ngFor="let i of [1,2,3,4]"></span>
                  </td>
                </tr>

                <tr *ngIf="!dataLoading() && filteredBatches.length === 0">
                  <td colspan="8" class="empty-cell">
                    <span>{{ hasActiveFilters ? 'No batches match the selected filters.' : 'No batches in progress.' }}</span>
                    <button type="button" class="btn-inline-clear" *ngIf="hasActiveFilters" (click)="clearFilters()">Clear filters</button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="sources-card">
          <div class="card-header">
            <div>
              <h3 class="card-title">Connected Sources</h3>
              <p class="card-caption">Live document connections</p>
            </div>
            <a routerLink="/connectors" class="view-all-link">
              Manage
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
                <path d="M5 12h14"/><path d="M13 6l6 6-6 6"/>
              </svg>
            </a>
          </div>

          <div class="sources-list">
            <div class="source-item" *ngFor="let src of filteredSources">
              <div class="source-icon">
                <img [src]="sourceIcon(src.provider)" width="20" height="20" alt="" />
              </div>
              <div class="source-info">
                <span class="source-name" [title]="src.name">{{ src.name }}</span>
                <span class="source-docs">{{ src.provider === 'GitHub' ? src.connectionCount + ' repos' : formatDocCount(src.documentCount) }}</span>
              </div>
              <span class="source-status" [ngClass]="sourceStatusClass(src.status)">
                <span class="status-dot"></span>{{ src.status }}
              </span>
            </div>
          </div>

          <p class="sources-empty" *ngIf="filteredSources.length === 0">No sources match the selected filter.</p>
        </div>
      </div>
    </div>
  </div>

  <div class="modal-overlay" *ngIf="showConnectModal()" (click)="closeConnectModal()">
    <div class="connect-modal" (click)="$event.stopPropagation()" role="dialog" aria-modal="true" aria-labelledby="connect-modal-title">

      <ng-container *ngIf="connectStep() === 'list'">
        <div class="cm-header">
          <h3 class="cm-title" id="connect-modal-title">Connect a Data Source</h3>
          <button type="button" class="cm-close" (click)="closeConnectModal()" aria-label="Close">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
              <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
            </svg>
          </button>
        </div>
        <div class="connector-list">
          <div class="connector-row">
            <div class="ci-icon sp-icon">
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
                <rect width="24" height="24" rx="5" fill="#0078D4"/>
                <text x="12" y="17" text-anchor="middle" fill="white" font-size="13" font-weight="700" font-family="Segoe UI,sans-serif">S</text>
              </svg>
            </div>
            <div class="ci-info">
              <span class="ci-name">SharePoint</span>
              <span class="ci-desc">Keep current with content and updates from SharePoint document libraries, sites, and team spaces in your organization.</span>
            </div>
            <button type="button" class="btn-ci-connect" (click)="startSharePointConnect()" [disabled]="connectingSharePoint()">
              <span class="btn-spinner" *ngIf="connectingSharePoint()"></span>
              {{ connectingSharePoint() ? 'Connecting…' : 'Connect' }}
            </button>
          </div>
          <div class="connector-row">
            <div class="ci-icon gh-icon">
              <svg width="22" height="22" viewBox="0 0 24 24" fill="#0D1121">
                <path d="M12 2C6.477 2 2 6.477 2 12c0 4.418 2.865 8.166 6.839 9.489.5.092.682-.217.682-.482 0-.237-.009-.868-.014-1.703-2.782.605-3.369-1.342-3.369-1.342-.454-1.154-1.11-1.462-1.11-1.462-.908-.62.069-.608.069-.608 1.003.07 1.531 1.03 1.531 1.03.892 1.529 2.341 1.087 2.91.831.092-.646.35-1.086.636-1.336-2.22-.253-4.555-1.11-4.555-4.943 0-1.091.39-1.984 1.029-2.683-.103-.253-.446-1.27.098-2.647 0 0 .84-.269 2.75 1.025A9.578 9.578 0 0 1 12 6.836c.85.004 1.705.115 2.504.337 1.909-1.294 2.747-1.025 2.747-1.025.546 1.377.203 2.394.1 2.647.64.699 1.028 1.592 1.028 2.683 0 3.842-2.339 4.687-4.566 4.935.359.309.678.919.678 1.852 0 1.336-.012 2.415-.012 2.743 0 .267.18.579.688.481C19.138 20.163 22 16.418 22 12c0-5.523-4.477-10-10-10z"/>
              </svg>
            </div>
            <div class="ci-info">
              <span class="ci-name">GitHub</span>
              <span class="ci-desc">Keep current with content and updates from your GitHub organization repositories and code.</span>
            </div>
            <button type="button" class="btn-ci-connect" (click)="goToDataSources()">Connect</button>
          </div>
          <div class="connector-row">
            <div class="ci-icon mb-icon">
              <img src="/assets/icons/sources/outlook.svg" width="22" height="22" alt="" />
            </div>
            <div class="ci-info">
              <span class="ci-name">Mailbox</span>
              <span class="ci-desc">Keep current with content and updates from Microsoft Outlook email, calendar, and contacts from your organization.</span>
            </div>
            <button type="button" class="btn-ci-connect" (click)="goToDataSources()">Connect</button>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="connectStep() === 'success'">
        <div class="success-card">
          <div class="success-icon-wrap">
            <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="#22C55E" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="12" cy="12" r="10"/>
              <polyline points="9 12 11 14 15 10"/>
            </svg>
          </div>
          <h3 class="success-title">Your SharePoint connected successfully.</h3>
          <button type="button" class="btn-continue" (click)="continueToDashboard()">Continue to Dashboard</button>
        </div>
      </ng-container>

    </div>
  </div>
</div>
